import * as React from 'react';

import {AlertBox} from '../alert-box/alert-box';
import {ModalLightbox} from '../modal/modal-lightbox';
import {TextfieldWithButtons} from '../textfield/textfield-with-buttons';

import styles from './single-input-modal.module.css';

type Props = {
    title: string;
    onClose: (e?: React.SyntheticEvent<any>) => void;
    isSaving: boolean;
    buttonText?: string;
    subtitle?: string;
    errorMessage?: string | null | undefined;
    placeholder?: string;
    initialValue: string;
    inputType?: string;
    // To prevent form nesting, use lightbox instead of alertbox
    preventFormNesting?: boolean;
    /** This happens just before the button submits the form, so it will run before your form's onSubmit.
    Note: do not set `isSaving` to true inside the onSave handler, it prevents form submission somehow. */
    onSave: (inputValue: string, e?: React.ChangeEvent<HTMLInputElement>) => void;
    requireValue?: boolean;
    savingText?: string;
};

export class SingleInputModal extends React.PureComponent<Props> {
    static displayName = 'SingleInputModal';
    static defaultProps = {
        onSave: () => {},
        initialValue: '',
    };

    componentDidMount() {
        document.addEventListener('keydown', this.handleKeyDown);
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyDown);
    }

    render() {
        const {
            errorMessage,
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            onClose,
            preventFormNesting,
            ...restProps
        } = this.props;

        const formContents = (
            <TextfieldWithButtons
                {...restProps}
                name='singleInputModal'
                subtitle={this.props.subtitle}
                onCancel={this.props.onClose}
                onSave={this.props.onSave}
                focusOnMount={true}
                errorMessage={errorMessage}
                requireValue={this.props.requireValue}
            />
        );

        return preventFormNesting ? (
            <ModalLightbox onClose={this.props.onClose}>
                <div className={styles['modal-container']}>{formContents}</div>
            </ModalLightbox>
        ) : (
            <AlertBox onClose={this.props.onClose}>{formContents}</AlertBox>
        );
    }

    // @ts-expect-error
    handleKeyDown: KeyboardEventListener = (e) => {
        // Not using Nut.keys here since it isn't in scope within shells
        // keyCode 27 = Esc
        if (e.keyCode === 27 && !e.defaultPrevented) {
            e.preventDefault();
            this.props.onClose();
        }
    };
}
